<template>
  <v-container v-if="!loading">
    <v-row>
      <v-col cols="12" md="9" lg="7" class="mx-auto text-center pa-0">
        <h3>My Favorite Chefs</h3>
      </v-col>
      <v-col cols="12" sm="1">
        <v-btn fab dark color="primary" @click.prevent="refresh">
          <v-icon dark>cached</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="list && list.length > 0">
      <v-col cols="12" sm="4" v-for="chef in list" :key="chef.id" class="mb-2">
        <chef-view :selectedChef="chef" />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" sm="6" v-html="$t('Chef.favorite_empty')"> </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import ChefView from './public/ChefView'

export default {
  components: {
    ChefView
  },
  computed: {
    ...mapGetters({
      profile: 'profile',
      loading: 'loading'
    })
  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.$store.dispatch('loadProfile').then(profile => {
      console.log('ooooooooo1', profile.favorite_chefs)
      this.loadFavorites()
    })
  },
  watch: {
    profile(val, prev) {
      if (prev == null && val != null) {
        this.loadFavorites()
      }
    }
  },
  methods: {
    refresh() {
      this.$router.go(this.$router.currentRoute)
    },
    loadFavorites() {
      if (this.profile && this.profile.favorite_chefs) {
        console.log('Loading favorite_chefs:', this.profile.favorite_chefs)
        this.$store
          .dispatch('loadFavorites', {
            list: this.profile.favorite_chefs,
            type: 'profile'
          })
          .then(list => {
            console.log('Loaded Favorite Chefs:', list)
            this.list = list
          })
      } else {
        console.log('favorite_chefs is empty')
      }
    }
  }
}
</script>
